import { State } from 'app/gamma/src/modules/types';

export const isAnyPopoverCurrentlyOpen = (state: State): boolean =>
  state.ui.popovers.length !== 0;

export const isPopoverShown = (state: State, name: symbol | string): boolean =>
  state.ui.popovers.includes(name);
